export default __webpack_public_path__ + "media/images/images_v2/entete1-f322f41bba830f728365efe454753bd2.png";